export var PartnerUserAuthorizationRole;
(function (PartnerUserAuthorizationRole) {
    PartnerUserAuthorizationRole["ADMIN"] = "ADMIN";
    PartnerUserAuthorizationRole["BILLING"] = "BILLING";
    PartnerUserAuthorizationRole["DEVELOPER"] = "DEVELOPER";
})(PartnerUserAuthorizationRole || (PartnerUserAuthorizationRole = {}));
export var PartnerBillingType;
(function (PartnerBillingType) {
    PartnerBillingType["FIXED"] = "FIXED";
    PartnerBillingType["WORKSPACE"] = "WORKSPACE";
})(PartnerBillingType || (PartnerBillingType = {}));
export var PartnerInvoiceStatus;
(function (PartnerInvoiceStatus) {
    PartnerInvoiceStatus["UNPAID"] = "UNPAID";
    PartnerInvoiceStatus["PAID"] = "PAID";
    PartnerInvoiceStatus["CANCELED"] = "CANCELED";
    PartnerInvoiceStatus["EXPIRED"] = "EXPIRED";
})(PartnerInvoiceStatus || (PartnerInvoiceStatus = {}));
